/**
 * Author photo with a graceful initials fallback (Story 30.15) — never renders
 * a broken <img>; if the photo asset is missing/404s, shows an initials avatar.
 */
import { useState } from "react";
import { initialsOf } from "../../data/authors";

export function AuthorAvatar({
  name,
  photo,
  size = 80,
}: {
  name: string;
  photo?: string;
  size?: number;
}) {
  const [failed, setFailed] = useState(false);
  const px = `${size}px`;

  if (photo && !failed) {
    return (
      <img
        src={photo}
        alt={name}
        width={size}
        height={size}
        loading="lazy"
        onError={() => setFailed(true)}
        className="rounded-full object-cover"
        style={{ width: px, height: px }}
      />
    );
  }
  return (
    <div
      aria-label={name}
      className="flex items-center justify-center rounded-full bg-brand/10 font-semibold text-brand"
      style={{ width: px, height: px, fontSize: `${Math.round(size / 2.6)}px` }}
    >
      {initialsOf(name)}
    </div>
  );
}
